export default "__VITE_ASSET__BGHmw10q__"